import { useCallback, useState } from "react";
import moment from "moment";
import { fetchOutlookEmailByAddress } from "../../redux/constants/integrationApi";

const extractEmail = (str) => {
  const match = str?.match(/<(.+?)>/);
  return match ? match[1].trim() : str?.trim() || "";
};

export const useOutlook = () => {
  const [loading, setLoading] = useState(false);

  const fetchEmails = useCallback(async ({ filterEmail, pageToken = "", pagerequire = 10, pagenumber = 1  }) => {
    try {
      setLoading(true);

      const response = await fetchOutlookEmailByAddress(filterEmail, pageToken, pagerequire, pagenumber);

      if (response?.status === false) {
        return {
          records: [],
          nextPageToken: "",
          totalEmails: 0,
          totalPages: 1,
          currentPage: pagenumber,
          signinRequire: false,
          error: response?.message || "Unable to fetch emails.",
        };
      }

      const emails = response?.data?.emails || [];
      const loggedInEmail = String(
        window.localStorage.getItem("outlookEmail") || "",
      ).toLowerCase();

      return {
        records: emails.map((email) => {
          const emailDate = email.date || "";
          const parsedDate = emailDate
            ? moment.utc(emailDate, "M/D/YYYY h:mm:ss A").local()
            : null;
          const from = email.from || "";
          const to = Array.isArray(email.to)
            ? email.to.join(", ")
            : email.to || "";
          const cc = Array.isArray(email.cc)
            ? email.cc.join(", ")
            : email.cc || "";

          return {
            id: email.id,
            threadId: email.conversationId || "",
            from,
            to,
            cc,
            subject: email.subject || "No Subject",
            body: email.body || email.snippet || "No email body available.",
            bodyContentType: email.bodyContentType || "html",
            snippet: email.snippet || "",
            attachments: email.attachments || [],
            date: parsedDate?.isValid() ? parsedDate.format("DD/MM/YYYY") : "",
            time: parsedDate?.isValid() ? parsedDate.format("HH:mm") : "",
            direction:
              // (Array.isArray(email.labelIds) &&
              //   email.labelIds.includes("SENT")) ||
              extractEmail(from).toLowerCase() === loggedInEmail
                ? "sent"
                : "received",
          };
        }),
        nextPageToken: response?.data?.nextPageToken || "",
        totalEmails: response?.data?.resultSizeEstimate || 0,
        totalPages: Math.ceil(
          (response?.data?.resultSizeEstimate || 0) / pagerequire,
        ),
        currentPage: pagenumber,
        pageSize: pagerequire,
        signinRequire: response?.status === 401,
      };
    } catch (error) {
      console.error("Error fetching emails:", error);
      return {
        records: [],
        nextPageToken: "",
        totalEmails: 0,
        totalPages: 1,
        currentPage: pagenumber,
        signinRequire: error?.response?.status === 401,
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch emails.",
      };
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, fetchEmails };
};
